var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 53,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.038.114C20.574.114.475 26.149.475 26.149S20.57 52.187 46.038 52.187c19.477 0 45.562-26.042 45.562-26.042S65.515.114 46.038.114zm0 42.258c-8.94 0-16.224-7.276-16.224-16.23 0-8.937 7.284-16.227 16.224-16.227 8.937 0 16.224 7.283 16.224 16.227 0 8.947-7.287 16.23-16.224 16.23zm0-25.693c-5.228 0-9.47 4.239-9.47 9.47 0 5.231 4.239 9.473 9.47 9.473 5.231 0 9.474-4.245 9.474-9.48 0-5.221-4.243-9.463-9.474-9.463z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "e6f85134c4a606d8cb7d38c02139e426.svg";
export { SvgEye as ReactComponent };